<template>
  <section class="max-w-[1440px] mx-auto px-12 py-12 space-y-12">

    <!-- HEADER -->
    <header class="flex items-end justify-between">
      <div>
        <h2 class="text-4xl font-black tracking-tight">
          Campaigns
        </h2>
        <p class="text-slate-400 mt-2 max-w-2xl">
          Plan, evaluate, and manage influencer campaigns before activation.
        </p>
      </div>

      <button
        @click="newCamp()"
        class="bg-primary text-white px-8 py-4 rounded-xl
               font-bold text-xs uppercase tracking-wider
               hover:opacity-90 transition"
      >
        New Campaign
      </button>
    </header>

    <!-- KPIs -->
    <section class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <div
        v-for="kpi in kpis"
        :key="kpi.label"
        class="bg-white p-8 rounded-3xl premium-shadow
               border border-slate-50"
      >
        <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
          {{ kpi.label }}
        </p>
        <h3 class="text-4xl font-black mt-2">
          {{ kpi.value }}
        </h3>
      </div>
    </section>

    <!-- CAMPAIGN LIST -->
    <section
      class="bg-white rounded-[2.5rem] premium-shadow
             border border-slate-50 overflow-hidden"
    >
      <!-- TABLE HEADER -->
      <div class="grid grid-cols-12 px-8 py-5 border-b border-slate-50 text-[11px]
                  font-bold uppercase tracking-wider text-slate-400">
        <div class="col-span-3">Campaign</div>
        <div class="col-span-2">Objective</div>
        <div class="col-span-2">Influencers</div>
        <div class="col-span-2">Status</div>
        <div class="col-span-2">Last Updated</div>
        <div class="col-span-1"></div>
      </div>

      <!-- ROWS -->
      <div
        v-for="c in campaigns"
        :key="c.id"
        class="grid grid-cols-12 px-8 py-6 border-b border-slate-50
               hover:bg-slate-50/50 transition"
      >
        <!-- Campaign -->
        <div class="col-span-3">
          <p class="font-bold text-slate-900">
            {{ c.campaign_title }}
          </p>
          <p class="text-xs text-slate-400">
            {{ c.campaign_type }}
          </p>
        </div>

        <!-- Objective -->
        <div class="col-span-2 text-sm">
          {{ c.campaign_desc }}
        </div>

        <!-- Influencers -->
        <div class="col-span-2 text-sm">
          {{ c.influencers }} selected
        </div>

        <!-- Status -->
        <div class="col-span-2">
          <span
            class="px-3 py-1 rounded-full text-xs font-bold"
            :class="statusClass(c.campaign_status)"
          >
            {{ c.campaign_status }}
          </span>
        </div>

        <!-- Updated -->
        <div class="col-span-2 text-sm text-slate-400">
          {{ c.campaign_datetime }}
        </div>

        <!-- Action -->
        <div class="col-span-1 text-right">
          <button
            @click="viewDt(c.campaign_id)"
            class="text-xs font-bold uppercase tracking-wider
                   border-b border-slate-900"
          >
            View
          </button>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import { loadCampaignsApi } from "../apis/agencampapis";
export default {
  name: "AgencyCampaigns",

  data() {
    return {
      kpis: [
        { label: "Total Campaigns", value: 6 },
        { label: "Drafts", value: 3 },
        { label: "Ready for Review", value: 2 },
        { label: "Archived", value: 1 }
      ],

      campaigns: [],
      pageNo:0,
    };
  },
  async mounted() {

   const ldataRaw = sessionStorage.getItem("ldata");
   const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

   if (ldata) {
      this.user_id = ldata.user_id;
   }

   await this.loadCampaigns();
},
  methods: {
      async loadCampaigns() {

        const res = await loadCampaignsApi(this.user_id,this.pageNo+"");

        if (res && res.status) {

          this.kpis = res.kpis || [];
          this.campaigns = res.records || [];

        } else {

          console.log("Campaign API failed");
        }
    },
    statusClass(status) {
      if (status === "Draft") return "bg-slate-100 text-slate-700";
      if (status === "Ready") return "bg-emerald-50 text-emerald-700";
      if (status === "Archived") return "bg-slate-50 text-slate-400";
      return "";
    },
    viewDt(campaign_id){
        window.location.href = "/agency/campaigns/details/"+campaign_id;
    },
    newCamp(){
        window.location.href = "/agency/campaigns/new";
    },
  }
};
</script>
<style scoped>
/* ===============================
   Brand CAMPAIGNS – MOBILE PATCH
   =============================== */
@media (max-width: 640px) {

  /* Override Tailwind container padding */
  .px-12 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .py-12 {
    padding-top: 24px !important;
    padding-bottom: 48px !important;
  }

  /* Header */
  header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  header h2 {
    font-size: 26px !important;
    line-height: 1.2;
  }

  header p {
    font-size: 14px;
  }

  header button {
    width: 100%;
    justify-content: center;
    padding: 14px 16px !important;
  }

  /* KPI cards */
  .grid.md\\:grid-cols-4 {
    gap: 12px;
  }

  .grid.md\\:grid-cols-4 > div {
    padding: 16px !important;
    border-radius: 18px !important;
  }

  .grid.md\\:grid-cols-4 h3 {
    font-size: 24px !important;
  }

  /* Hide table header */
  .grid.grid-cols-12.px-8.py-5 {
    display: none;
  }

  /* Campaign rows → stacked cards */
  .grid.grid-cols-12.px-8.py-6 {
    display: block;
    padding: 16px !important;
    border-bottom: 1px solid #f1f5f9;
  }

  /* Reset column spans */
  .grid.grid-cols-12.px-8.py-6 > div {
    grid-column: auto / auto;
    width: 100%;
    margin-bottom: 10px;
  }

  /* Campaign name */
  .grid.grid-cols-12.px-8.py-6 p.font-bold {
    font-size: 15px;
  }

  /* Secondary text */
  .grid.grid-cols-12.px-8.py-6 p.text-xs,
  .grid.grid-cols-12.px-8.py-6 div.text-sm,
  .grid.grid-cols-12.px-8.py-6 div.text-slate-400 {
    font-size: 13px;
  }

  /* Status pill spacing */
  .grid.grid-cols-12.px-8.py-6 span.rounded-full {
    display: inline-block;
    margin-top: 4px;
  }

  /* Action button */
  .grid.grid-cols-12.px-8.py-6 .text-right {
    text-align: left;
    margin-top: 12px;
  }

  .grid.grid-cols-12.px-8.py-6 button {
    font-size: 11px;
  }

  /* Campaign list card radius */
  .rounded-\\[2\\.5rem\\] {
    border-radius: 20px !important;
  }
}

</style>